import type { HTMLAttributes } from 'react';
import React from 'react';
import type { CmsContentDictionary, CmsContentProps } from '$cms/index';
import { getImageByKey, getShortTextByKey } from '$cms/getDataByKey';
import { CLOUDINARY_URL } from '$constants/cloudinary';
import { useAppContext } from '$util/AppContext';
import { PartOfRenaultStatic } from '$quantum/molecules/PartOfRenault/PartOfReanultStatic';
import type { MediaQueryBreakpoint } from '$util/theme/breakpoints';

const getCmsData = (cmsData: CmsContentDictionary) => {
  const getShortText = getShortTextByKey.bind(cmsData);
  const getImage = getImageByKey.bind(cmsData);

  return {
    label: getShortText('partOfRenault.title', 'Part of'),
    logo: getImage('partOfRenault.image', {
      img: {
        original_secure_url: `${CLOUDINARY_URL}/logos/renault_white_ucyjxf.svg`,
        width: 87,
        height: 39,
      },
      alt: 'Backed by Renault',
      title: '',
    }),
  };
};

export interface PartOfRenaultProps extends HTMLAttributes<HTMLDivElement> {
  readonly preload?: boolean;
  readonly fromBreakpoint?: MediaQueryBreakpoint;
  readonly toBreakpoint?: MediaQueryBreakpoint;
  readonly layout?: 'vertical' | 'horizontal';
}

export function PartOfRenault(props: PartOfRenaultProps): JSX.Element {
  const {
    cmsContent: { dictionary },
  } = useAppContext<CmsContentProps>();

  const { label, logo } = getCmsData(dictionary);
  return <PartOfRenaultStatic {...props} label={label} logo={logo} />;
}
PartOfRenault.displayName = 'PartOfRenault';
